import React, {useEffect, useState} from "react";
import "./comparison.css";
import Meta from "utils/meta";
import SalesForceFeatures from "utils/ComparionData/salesForceFeatures";
import SalesForceDetailedFeatures from "utils/ComparionData/salesForceDetailedFeatures";
import SubPageHeader from "Component/SubPageHeader/subPageHeader";
import ComparisonTopTabs from "Component/ComparisonTopTabs/ComparisonTopTabs";
import ComparisonSideMenu from "Component/ComparisonSideMenu/ComparisonSideMenu";
import ComparisonFeatures from "Component/ComparisonFeatures/ComparisonFeatures";
import ComparisonSalientFeatures from "Component/ComparisonSalientFeatures/ComparisonSalientFeatures";
import DetailedComparisonTable from "Component/ComparisonFeatures/DetailedComparisonTable";

const Salesforce = () => {
  const sideMenu = [
    {name: "Best Real Estate CRM", link: "top-intro-section"},
    {name: "Features: Realtor vs Salesforce", link: "comparison-features-section"},
    {name: "Salient Features", link: "comparison-salient-features"},
    {name: "Detailed Comparison", link: "detailed-comparison"}
  ];
  const [activeDetailedComparison, setActiveDetailedComparison] = useState([]);

  const handleDetailedComparisonTab = (index) => {
    if (activeDetailedComparison.includes(index)) {
      setActiveDetailedComparison(activeDetailedComparison.filter(item => item !== index));
    } else {
      setActiveDetailedComparison([...activeDetailedComparison, index]);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (<>
      <Meta title="Sales Force | The Realtor Desk" description="" />
      <div className="sub-page--outer">
        <SubPageHeader
            title="Real Estate CRM: A Legacy of 10 Years by Industry Experts"
            subTitle="Our Real Estate CRM is crafted with a decade of industry expertise, specifically tailored to meet the challenges and demands of the real estate sector."
        />
        <ComparisonTopTabs
            activeTab={0}
        />
        <div className="container comparison-outer">
          <div className="comp-side--menu">
            <h4>Comparison Tools</h4>
            <ComparisonSideMenu
                sideMenu={sideMenu}
                currentActive={sideMenu[0].link}
            />
          </div>
          <div className="comp-side--content">
            <div className="top-title-section" id="top-intro-section">
              <h4>A CRM Designed Exclusively for Real Estate</h4>
              <p>Salesforce is a popular CRM software. However, it hasn’t been created exclusively for the Real Estate industry. Realtor Desk has been designed and developed by industry veterans with relevant sales and marketing expertise. It comes equipped with features that tackle real-world problems. What’s more, you can go live in just 15 days and save up to ₹6 Lakh per annum on the total cost of ownership.</p>
            </div>
            <ComparisonFeatures
                features={SalesForceFeatures}
                title="Better Real Estate with Realtor Features"
                platform="Salesforce"
            />
            <ComparisonSalientFeatures
                title="Salient Features of Realtor Real Estate: An Alternative to Salesforce CRM for Real Estate"
            />
            <div className="detailed-comparison-section--outer" id="detailed-comparison">
              <h4>How Realtor Real Estate is a Better Alternative to Salesforce</h4>
              <div className="comparison-table--accordion">
                {SalesForceDetailedFeatures.map((singleFeature, index) => (
                    <div key={index} className="comparison--accordion-item">
                      <div className={`comparison--accordion-title ${activeDetailedComparison.includes(index) ? "active-title" : ""}`} onClick={() => handleDetailedComparisonTab(index)}>
                        <span>{singleFeature.tab_heading}</span>
                        {activeDetailedComparison.includes(index) ? (<i className="fa fa-minus" />) : (<i className="fa fa-plus" />)}
                      </div>
                      {activeDetailedComparison.includes(index) && (
                          <DetailedComparisonTable
                              features={singleFeature.tab_info}
                              platform="Hubspot"
                              savings={singleFeature.total_savings ? singleFeature.total_savings : ""}
                              note={singleFeature.notes ? singleFeature.notes : ""}
                          />
                      )}
                    </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Salesforce;
